import * as React from 'react';

import { useParams } from 'js/lib/useRouter';

import CourseRecommendationsModuleNotConfigurable from 'bundles/unified-description-page-common/components/recommendations/CourseRecommendationsModuleNotConfigurable';
import ExploreMoreCourseRecommendations from 'bundles/unified-description-page-common/components/recommendations/ExploreMoreCourseRecommendations';
import type { CollectionEntityFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/CollectionEntityFragment';
import type { EnterpriseCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/EnterpriseCoursePageQuery';
import { COURSE_NAV_ITEMS } from 'bundles/unified-description-page-common/utils/getPageNavigationLinks';
import { useStreamlinedXDP } from 'bundles/unified-description-page-common/utils/useStreamlinedXDP';

type Props = {
  pageData: EnterpriseCoursePageFieldsFragment;
};

const EnterpriseCourseRecommendationsModuleRenderer = ({ pageData }: Props) => {
  const urlParams = useParams();
  const enterpriseUrl = `/programs/${urlParams.programSlug}`;
  const isStreamlinedXDP = useStreamlinedXDP();

  if (isStreamlinedXDP) {
    return (
      <ExploreMoreCourseRecommendations
        anchorId={COURSE_NAV_ITEMS.RECOMMENDATIONS}
        domainName={pageData.domains?.[0]?.subdomainName || pageData.domains?.[0]?.domainName}
        recommendationsCollection={
          pageData && pageData.relatedRecommendations
            ? (pageData.relatedRecommendations as CollectionEntityFragment[]).map((collection) => ({
                ...collection,
                link: `${enterpriseUrl}${collection.link}`,
              }))
            : null
        }
        relatedCoursesCollection={pageData?.relatedCourses?.map((collection) => ({
          ...collection,
          link: `${enterpriseUrl}${collection.link}`,
        }))}
      />
    );
  }

  const getRecsCollections = (recsCollections: CollectionEntityFragment[] | null | undefined) => {
    if (recsCollections === null || recsCollections === undefined) return undefined;
    return recsCollections.map((recsCollection: CollectionEntityFragment): CollectionEntityFragment => {
      const collection = { ...recsCollection, link: `${enterpriseUrl}${recsCollection.link}` };
      return collection;
    });
  };

  return (
    <CourseRecommendationsModuleNotConfigurable
      anchorId={COURSE_NAV_ITEMS.RECOMMENDATIONS}
      domainName={pageData.domains?.[0]?.domainName}
      recommendationsCollection={getRecsCollections(pageData?.relatedRecommendations as CollectionEntityFragment[])}
      relatedCoursesCollection={getRecsCollections(pageData?.relatedCourses)}
    />
  );
};

export default EnterpriseCourseRecommendationsModuleRenderer;
